import { render, staticRenderFns } from "./multi_slider.vue?vue&type=template&id=2b35013e&"
import script from "./multi_slider.vue?vue&type=script&lang=js&"
export * from "./multi_slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20251203080612/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b35013e')) {
      api.createRecord('2b35013e', component.options)
    } else {
      api.reload('2b35013e', component.options)
    }
    module.hot.accept("./multi_slider.vue?vue&type=template&id=2b35013e&", function () {
      api.rerender('2b35013e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/form/multi_slider.vue"
export default component.exports